import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import Cards from 'react-credit-cards';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import deletePaymentMethodById from '../../service/api/paymentGateway/deletePaymentMethodById';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';

const DeleteCard = ({
    deleteCardTrigger,
    handleCloseDeleteCard,
    particularCard,
}) => {

    const dispatch = useDispatch();

    const [lastFourDigitCard, setLastFourDigitCard] = useState('');
    const [initialMonthExpCard, setInitialMonthExpCard] = useState('');
    const [initialYearExpCard, setInitialYearExpCard] = useState('');
    const [initialNameOnCard, setInitialNameOnCard] = useState('');
    const [particularPaymentMethodId, setParticularPaymentMethodId] = useState('');

    const setInitialCardDetails = (particularCard) => {

        setParticularPaymentMethodId(particularCard?.id);
        setInitialNameOnCard(particularCard?.billing_details?.name);
        setLastFourDigitCard(`0000 0000 0000 ${particularCard?.card?.last4}`);
        if (particularCard?.card?.exp_month < 10) {
            setInitialMonthExpCard(`0${particularCard?.card?.exp_month}`);
        } else {
            setInitialMonthExpCard(particularCard?.card?.exp_month);
        }
        setInitialYearExpCard((particularCard?.card?.exp_year % 100).toString());
    }

    useEffect(() => {
        setInitialCardDetails(particularCard);
    }, [])

    // console.log(particularCard, 'particularCard');

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const handleDeleteCard = () => {
        setApiResponse(true);

        let details = new FormData();

        details.append("payment_method_id", particularPaymentMethodId);
        details.append("user_id_ids", localStorage.getItem('user_id'));

        dispatch(
            deletePaymentMethodById(
                details,
                (res) => {
                    // console.log(res)

                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    handleCloseDeleteCard();
                    setApiResponse(false);

                    // setTimeout(() => {
                    //     handleCloseDeleteCard();
                    //     setApiResponse(false);
                    // }, 1500);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    return (
        <>
            <Modal className="fade" show={deleteCardTrigger}
                // onHide={handleClose} 
                centered
            >
                {/* <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>{"Delete card"}</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseDeleteCard()}
                    >

                    </Button>
                </Modal.Header> */}
                <Modal.Body>

                    {/* Main modal content */}

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseDeleteCard()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Are you sure to delete this card?"}
                                        </span>
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 px-0'>
                                        <Cards
                                            number={lastFourDigitCard}
                                            name={initialNameOnCard}
                                            expiry={`${initialMonthExpCard}${initialYearExpCard}`}
                                        />
                                    </div>
                                </div> */}


                                <div className='row mx-0'>
                                    <div className={`col-12 px-0 `}>

                                        <div className='row mx-0' >
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>
                                                    <div className='col-12  px-0 d-flex align-items-center'>
                                                        {particularCard.is_default_card ? <div className='font-w600 mb-1 row text-success'>
                                                            {particularCard.is_default_card && <span>{"Primary payment method"}</span>}
                                                        </div> :
                                                            <>
                                                                <div className='d-flex fs-5 fw-bold text-black'>
                                                                    <span>{`${(particularCard?.card?.brand).toUpperCase()} – *${particularCard?.card?.last4}`}</span>
                                                                </div>
                                                            </>
                                                        }



                                                    </div>
                                                </div>

                                                {particularCard.is_default_card &&
                                                    <div className='row mx-0'>
                                                        <div className='col-12  px-0'>
                                                            <div className='d-flex fs-5 fw-bold text-black'>
                                                                <span>{`${(particularCard?.card?.brand).toUpperCase()} – *${particularCard?.card?.last4}`}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }


                                                <div className='row mx-0'>
                                                    <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex fs-6 font-w500 '>
                                                            <span>{`${particularCard?.billing_details?.name}`}</span>
                                                        </div>

                                                        <div className='d-flex fs-6 font-w500 '>
                                                            <span>{`${particularCard?.card?.exp_month}/${particularCard?.card?.exp_year}`}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-4'>


                                    <div className='col-12 px-0  mb-2'>
                                        <PrimaryButton
                                            onClick={(e) => handleDeleteCard(e)}
                                            buttonName={"Delete card"}
                                            type={"submit"}
                                            loadingMessage={"Loading..."}
                                            isLoading={apiResponce}
                                            style={{ width: "100%", background: 'red', border: 'none' }}
                                        />
                                    </div>

                                </div>


                            </>



                        </div>
                    </div>

                    {/* <div style={{ fontSize: '15px' }}>
                        <p>{"Are you sure to delete this card"}</p>
                    </div>
                    <div>
                        <Cards
                            number={lastFourDigitCard}
                            name={initialNameOnCard}
                            expiry={`${initialMonthExpCard}${initialYearExpCard}`}
                        />
                    </div>



                    <div className='d-flex align-items-center' style={{ marginTop: '20px', justifyContent: 'flex-end' }}>

                        <PrimaryButton
                            buttonName={"Delete"}
                            onClick={handleDeleteCard}
                        />
                    </div> */}
                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}
        </>
    )
}

export default DeleteCard